import React, { ReactElement } from 'react';

import { WEB_APP_SIGNUP_URL } from '../../../../../globals';
import { Assets } from '../../../../../utils/assets';
import MaxWidth from '../../../../shared/MaxWidth';
import * as S from './Hero.styles';

export const Hero = (): ReactElement => {
  const handleClickCta = () => {
    window.location.href = WEB_APP_SIGNUP_URL;
  }

  return (
    <S.Wrapper>
      <MaxWidth>
        <S.Content>
          <S.TextBox>
            <S.Caption>Music made for ADHD</S.Caption>
            <S.DescriptionContainer>
              <S.Description>
                <S.CheckMarkIcon alt={Assets.images.checkCircleGradient.alt} src={Assets.images.checkCircleGradient.url} />
                Stimulation without distraction
              </S.Description>
              <S.Description>
                <S.CheckMarkIcon alt={Assets.images.checkCircleGradient.alt} src={Assets.images.checkCircleGradient.url}  />
                Backed by peer-reviewed research
              </S.Description>
              <S.Description>
                <S.CheckMarkIcon alt={Assets.images.checkCircleGradient.alt} src={Assets.images.checkCircleGradient.url}  />
                Focus better in minutes
              </S.Description>
            </S.DescriptionContainer>
            <S.CtaWrapper>
              <S.ButtonLink onClick={handleClickCta}>
                <span>TAKE THE QUIZ</span>
                <img alt="chevron right" src="https://cdn.brain.fm/icons/chevron-right.svg"  />
              </S.ButtonLink>
            </S.CtaWrapper>
            <S.NsfWrapper>
              <S.NsfImage alt={Assets.images.nsfLogo.alt} src={Assets.images.nsfLogo.url}/>
              <S.NsfText>
                Supported by the National <br /> Science Foundation
              </S.NsfText>
            </S.NsfWrapper>
          </S.TextBox>
        </S.Content>
      </MaxWidth>
      <S.ImageWrapper>
        <S.Image alt={Assets.images.adhdBrainBg.alt} src={Assets.images.adhdBrainBg.url}/>
      </S.ImageWrapper>
    </S.Wrapper>
  );
};
